module.exports = __webpack_public_path__ + "img/klarna-rechnung-alt.17780b34.png";